import { useEffect } from "react";
import PropTypes from "prop-types";
import { Card, Dropdown } from "@/config/antd";
import Avatar from "@/components/common/Avatar";
import { useDispatch, useSelector } from "react-redux";
import {
  selectMultipleUsers,
  fetchMultipleUsersAsync,
  selectIsLoadingMultiple,
} from "@/store/redux/slices/user/user_slice";
import CustomMoreOptions from "@/components/specific/Custom_More_Options";

const LogisticsTab = ({ logistics = [] }) => {
  const dispatch = useDispatch();
  const users = useSelector(selectMultipleUsers);
  const isLoading = useSelector(selectIsLoadingMultiple);

  useEffect(() => {
    const officerIds = logistics.flatMap((item) => item.officerInCharge || []);
    if (officerIds.length > 0) {
      dispatch(fetchMultipleUsersAsync(officerIds));
    }
  }, [dispatch, logistics]);

  const logisticsData = logistics.flatMap((item) => {
    // If no officers are assigned, create one card with "Not Assigned"
    if (!item.officerInCharge || item.officerInCharge.length === 0) {
      return [
        {
          id: `${item._id}-no-officer`,
          image: item.image || "https://example.com/car1.jpg",
          carName: item.name || "Not Assigned",
          carType: item.vehicle || "Not Assigned",
          owner: "Not Assigned",
        },
      ];
    }

    // Create separate cards for each officer
    return item.officerInCharge.map((officerId) => {
      const user = users.find((u) => u._id === officerId);
      return {
        id: `${item._id}-${officerId}`,
        image: item.image || "https://example.com/car1.jpg",
        carName: item.name || "Not Assigned",
        carType: item.vehicle || "Not Assigned",
        owner: user ? user.fullname : "Not Assigned",
      };
    });
  });

  const moreMenu = {
    items: [
      {
        key: "edit",
        label: "Edit Details",
      },
      {
        key: "remove",
        label: "Remove Vehicle",
        danger: true,
      },
    ],
  };

  return (
    <div className="space-y-4">
      {isLoading ? (
        <div>Loading...</div>
      ) : (
        logisticsData.map((logistics) => (
          <Card
            key={logistics.id}
            className="w-full shadow-sm hover:shadow-md transition-shadow">
            <div className="flex items-center justify-between gap-4">
              {/* Image Section */}
              <div className="flex-shrink-0">
                <Avatar
                  src={logistics.image}
                  size={64}
                  shape="square"
                  className="rounded-lg"
                />
              </div>

              {/* Info Section */}
              <div className="flex-grow text-left">
                <h4 className="text-black text-regular font-semibold mb-1">
                  {logistics.carName}
                </h4>
                <div className="space-y-1">
                  <p className="text-darkGrey text-small">
                    <span className="font-medium">{logistics.carType}</span>
                  </p>
                  <p className="text-darkGrey text-small">
                    <span className="font-medium">{logistics.owner}</span>
                  </p>
                </div>
              </div>

              {/* Actions Section */}
              <div className="flex-shrink-0">
                <Dropdown
                  menu={moreMenu}
                  placement="bottomRight"
                  trigger={["click"]}>
                  <CustomMoreOptions
                    variant="filled"
                    onClick={(e) => e.stopPropagation()}
                    color="black"
                    orientation="vertical"
                    size="small"
                  />
                </Dropdown>
              </div>
            </div>
          </Card>
        ))
      )}
    </div>
  );
};

LogisticsTab.propTypes = {
  logistics: PropTypes.array,
};

export default LogisticsTab;
